<div
  class="filter-header d-flex p-3 align-items-center justify-content-between"
  >
  <div class="d-flex align-items-center">{{ 'HOME_COMPONENTS.MASTER_FILTER.FILTERS' | translate }}</div>

  <button
    kendoButton
    fillMode="clear"
    rounded="large"
    class="p-1"
    themeColor="primary"
    (click)="saveView()"
    [size]="'small'"
    >
    <div class="d-flex align-items-center">
      <fa-icon [icon]="faSave" class="w-px-20 me-1"></fa-icon>
      <div class="small-text">{{ 'HOME_COMPONENTS.COMMON.SAVE' | translate }}</div>
    </div>
  </button>
</div>
@if ({ showColumnsPopUp: false, showfilterpopup: false }; as variables) {
  <div
    class="filter-container pe-3 ps-3 pt-2"
    #masterFilters
    >
    <div class="row">
      <div class="col-12">
        <label class="small">{{ 'HOME_COMPONENTS.MASTER_FILTER.CONTRACT' | translate }}</label>
      </div>
      <div class="col-12">
        <kendo-dropdownlist
          [data]="viewList"
          textField="contractTitle"
          valueField="contractName"
          [value]="selectedContract()"
          [loading]="viewList === undefined"
          (valueChange)="contractChange($event)"
          >
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <label class="small">{{ 'HOME_COMPONENTS.MASTER_FILTER.WORK_ORDER_STATUS' | translate }}</label>
      </div>
      <div class="col-12">
        <div class="d-flex">
          <kendo-multiselect
            [data]="woStatusOptionsFiltered"
            [filterable]="true"
            [allowCustom]="false"
            textField="value"
            valueField="value"
            [popupSettings]="{ popupClass: 'mt-1' }"
            [value]="woStatusOptionDefault"
            (valueChange)="onChangeWOStatus($event)"
            (filterChange)="handleChangeWOStatus($event)"
            [checkboxes]="true"
            [autoClose]="false"
            [loading]="viewList === undefined"
            >
            <ng-template kendoMultiSelectHeaderTemplate>
              <div class="my-1 ps-2">
                <input
                  kendoCheckBox
                  type="checkbox"
                  (change)="toggleSelectAll()"
                  name="select-all"
                  [(ngModel)]="selectAll"
                  />
                <label class="ms-2 fw-bold" for="select-all">
                  {{
                  selectAll
                  ? ('HOME_COMPONENTS.MASTER_FILTER.UNSELECT_ALL' | translate)
                  : ('HOME_COMPONENTS.MASTER_FILTER.SELECT_ALL' | translate)
                }}</label>
              </div>
            </ng-template>
          </kendo-multiselect>
        </div>
      </div>
    </div>
    <hr />
    <div class="panelbar-wrapper mt-2" id="field-button">
      <div class="column-options position-relative">
        <button
          class="w-100"
          [disabled]="!viewList"
          kendoButton
          [themeColor]="'secondary'"
          look="outline"
          size="small"
          (click)="variables.showColumnsPopUp = !variables.showColumnsPopUp"
          >
          <fa-icon [icon]="faPlus" class="w-px-20 me-1"></fa-icon>
          {{ 'HOME_COMPONENTS.MASTER_FILTER.ADD_ADDITIONAL_FILTERS' | translate }}
        </button>
        @if (viewList && variables.showColumnsPopUp) {
          <app-data-selector-popup
            [isColumnOption]="viewList && variables.showColumnsPopUp"
            [dataArray]="preFilterList"
            [anchor]="hideAnchor"
            (checkedChangeEvent)="columnCheckChange($event)"
            (closeEvent)="variables.showColumnsPopUp = !variables.showColumnsPopUp"
            >
          </app-data-selector-popup>
        }
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between">
          <label class="small">{{ 'HOME_COMPONENTS.MASTER_FILTER.PLANNED_INSTALL_DATE' | translate }}</label>
          @if (plannedDateFilter) {
            <kendo-dropdownlist
              class="plannedinstallddl"
              [data]="plannedDateFilter"
              textField="text"
              valueField="value"
              [size]="'small'"
              [loading]="viewList === undefined"
              [value]="selectedPlannedDateFilter"
              (valueChange)="plannedDateFilterChange($event)"
              >
            </kendo-dropdownlist>
          }
        </div>
      </div>
      @if (selectedPlannedDateFilter?.value === 'Custom') {
        <div
          class="col-12 mt-1"
          >
          <div class="row">
            <div class="col-6 pe-2">
              <label class="small">{{ 'HOME_COMPONENTS.MASTER_FILTER.START_DATE' | translate }}</label>
              <kendo-datepicker
                class="w-100"
                [value]="plannedInstallDates().start"
                (valueChange)="onChangeStartDate($event)"
              ></kendo-datepicker>
            </div>
            <div class="col-6 ps-2">
              <label class="small">{{ 'HOME_COMPONENTS.MASTER_FILTER.END_DATE' | translate }}</label>
              <kendo-datepicker
                class="w-100"
                [value]="plannedInstallDates().end"
                (valueChange)="onChangeEndDate($event)"
              ></kendo-datepicker>
            </div>
          </div>
        </div>
      }
    </div>
    @for (item of Filters; track item; let i = $index) {
      <div class="mt-2 filters">
        @if (item?.field) {
          <div
            class="row align-items-center justify-content-between"
            [style.position]="'relative'"
            >
            <div class="col">
              <label class="small">{{ getTextbasedonFieldName(item.field) }}</label>
            </div>
            <div class="col-auto d-flex">
              <kendo-dropdownbutton
                class="mx-2 columns-config-pop-container"
                [data]="filterTypes"
                textField="text"
                themeColor="primary"
                [size]="'small'"
                [fillMode]="'outline'"
                (itemClick)="filterTypesClicked($event, item)"
                [popupSettings]="{ popupClass: 'pppopup' }"
                >
                {{
                item.operator
                ? getTextForFilterDropDown(item.operator)
                : filterTypes[0].text
                }}
                <fa-icon [icon]="faChevronDown" class="w-px-20 ms-1"></fa-icon>
              </kendo-dropdownbutton>
              <button
                class=""
                kendoButton
                look="outline"
                [themeColor]="'secondary'"
                [size]="'small'"
                (click)="restoreColPrefilter(item)"
                >
                <fa-icon [icon]="faTrashCan"></fa-icon>
              </button>
            </div>
            <div class="col-12 mt-2">
              <div class="row align-items-center justify-content-between">
                <div class="col">
                  @if (getTypePrefilter(item) === 'date') {
                    <input
                      class="filter-input-val form-control"
                      [type]="getTypePrefilter(item) == 'date' ? 'date' : 'text'"
                      [value]="item.value"
                      [(ngModel)]="item.value"
                      [disabled]="isFiltertypeWithoutValue(item.operator)"
                      />
                  }
                  @if (getTypePrefilter(item) !== 'date') {
                    <kendo-multiselect
                      [(ngModel)]="item.value"
                      (open)="loadDataPrefilter(item)"
                      [data]="item.dropDownList"
                      [filterable]="true"
                      [loading]="loadingFilterData"
                      [allowCustom]="true"
                      [disabled]="isFiltertypeWithoutValue(item.operator)"
                      (valueChange)="valueChangePrefilter($event, item.field)"
                      (filterChange)="handleChangePrefilter($event, item.field)"
                      [checkboxes]="true"
                      [autoClose]="false"
                      (paste)="onPaste($event, i)"
                      (keydown.enter)="onEnter(i)"
                      [clearButton]="true"
                      #multiselect
                      >
                    </kendo-multiselect>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
    <!-- <hr /> -->
  </div>
}
<div class="row p-3 filter-footer">
  <div class="col-6 pe-2">
    <button
      kendoButton
      look="outline"
      [themeColor]="'secondary'"
      class="w-100 py-2"
      [title]="'HOME_COMPONENTS.MASTER_FILTER.CLEAR_FILTERS' | translate"
      (click)="clearFilters()"
      >
      {{ 'HOME_COMPONENTS.MASTER_FILTER.RESET' | translate }}
    </button>
  </div>
  <div class="col-6 ps-2">
    <button
      [disabled]="disabled()"
      class="w-100 py-2"
      kendoButton
      fillMode="solid"
      rounded="large"
      themeColor="primary"
      [title]="'HOME_COMPONENTS.MASTER_FILTER.APPLY_FILTERS' | translate"
      (click)="applyFilters()"
      >
      {{ 'HOME_COMPONENTS.MASTER_FILTER.APPLY' | translate }}
    </button>
  </div>
</div>
